// extracted by mini-css-extract-plugin
export default {"underlineLink":"Authentification_underlineLink__Q+ED7"};